import { gql } from '../../../artifacts/gql';

export const resendPhoneVerificationCode = gql(`
  mutation webResendPhoneVerificationCodeMutation {
    collectResendPhoneVerificationCode {
        successful
        messages {
            field
            message
            code
        }
        result
    }
  }
`);
